/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_shipped_in_24 = /** @type {(inputs: {}) => string} */ () => {
	return `Odesláno do 24 hodin`
};

const da_attributes_shipped_in_24 = /** @type {(inputs: {}) => string} */ () => {
	return `Afsendes inden for 24 timer`
};

const de_attributes_shipped_in_24 = /** @type {(inputs: {}) => string} */ () => {
	return `In 24 Stunden versendet`
};

const en_attributes_shipped_in_24 = /** @type {(inputs: {}) => string} */ () => {
	return `Shipped in 24h`
};

const es_attributes_shipped_in_24 = /** @type {(inputs: {}) => string} */ () => {
	return `Enviado en 24 horas`
};

const fr_attributes_shipped_in_24 = /** @type {(inputs: {}) => string} */ () => {
	return `Expédié en 24h`
};

const hu_attributes_shipped_in_24 = /** @type {(inputs: {}) => string} */ () => {
	return `24 Órán Belül Szállítják`
};

const it_attributes_shipped_in_24 = /** @type {(inputs: {}) => string} */ () => {
	return `Spedito entro 24 ore`
};

const nl_attributes_shipped_in_24 = /** @type {(inputs: {}) => string} */ () => {
	return `Binnen 24 uur verzonden`
};

const pl_attributes_shipped_in_24 = /** @type {(inputs: {}) => string} */ () => {
	return `Wysyłka w ciągu 24 godzin`
};

const pt_attributes_shipped_in_24 = /** @type {(inputs: {}) => string} */ () => {
	return `Enviado no prazo de 24 horas`
};

const sv_attributes_shipped_in_24 = /** @type {(inputs: {}) => string} */ () => {
	return `Leverans inom 24 timmar`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_shipped_in_24 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_shipped_in_24(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_shipped_in_24", locale)
	if (locale === "cs") return cs_attributes_shipped_in_24(inputs)
	if (locale === "da") return da_attributes_shipped_in_24(inputs)
	if (locale === "de") return de_attributes_shipped_in_24(inputs)
	if (locale === "en") return en_attributes_shipped_in_24(inputs)
	if (locale === "es") return es_attributes_shipped_in_24(inputs)
	if (locale === "fr") return fr_attributes_shipped_in_24(inputs)
	if (locale === "hu") return hu_attributes_shipped_in_24(inputs)
	if (locale === "it") return it_attributes_shipped_in_24(inputs)
	if (locale === "nl") return nl_attributes_shipped_in_24(inputs)
	if (locale === "pl") return pl_attributes_shipped_in_24(inputs)
	if (locale === "pt") return pt_attributes_shipped_in_24(inputs)
	return sv_attributes_shipped_in_24(inputs)
};
export { attributes_shipped_in_24 as "attributes.shipped_in_24" }